import { ActionTypes } from 'utils/constants';

export const upgradeSubscription = (state = {}, action) => {
    switch(action.type) {
        case ActionTypes.UPGRADE_SUBSCRIPTION + '_PENDING': {
            return {
                ...state,
                processing: true
            };
        }
        case ActionTypes.UPGRADE_SUBSCRIPTION + '_REJECTED': {
            return {
                ...state,
                processing: false,
                error: true
            };
        }
        case ActionTypes.UPGRADE_SUBSCRIPTION + '_FULFILLED': {
            return {
                ...state,
                processing: false
            };
        }
        default: {
            return state;
        }
    }
};
